import { render, staticRenderFns } from "./UserSettingAccount.vue?vue&type=template&id=46df9bc8&"
import script from "./UserSettingAccount.vue?vue&type=script&lang=js&"
export * from "./UserSettingAccount.vue?vue&type=script&lang=js&"
import style0 from "./UserSettingAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports